/** Field help for the translation glossary editor (metaplan A6). */
export const GLOSSARY_HELP = {
  operator: {
    title: 'Operator',
    body: 'A glossary belongs to one operator and is applied by every machine translation of that operator — auto-translated tag values and the AI editor\'s translations. The operator\'s own name is always kept as is; it needs no entry.',
    story: 'translation-glossary',
  },
  term: {
    title: 'Term',
    body: 'The word or phrase as it appears in the source text, e.g. "Colosseum Underground". Whole words only; longer terms win over shorter ones they contain.',
    story: 'translation-glossary',
  },
  kind: {
    title: 'Kind',
    body: 'Keep verbatim: the term is never translated (brand names, tour names). Preferred translations: the term is replaced by your translation for that language — the model never sees it, so it always comes out exactly as written.',
    story: 'translation-glossary',
  },
  sourceLang: {
    title: 'Source language',
    body: 'Only apply the term when translating FROM this language. Empty applies it whatever the source language; an entry for a specific language wins over one for any.',
    story: 'translation-glossary',
  },
  caseSensitive: {
    title: 'Case sensitive',
    body: 'Off: "Meeting Point" and "meeting point" both match. A kept term keeps the case it was written with in the text.',
    story: 'translation-glossary',
  },
} as const;
